<template>
  <div class="share">
  </div>
</template>

<script>
export default {
  name: 'share',
  created() {
    const ua = navigator.userAgent
    const isWeixin = !!/MicroMessenger/i.test(ua)
    const shareData = {
      title: '上小程序搜车立即领取一份现金福利！',
      desc: '搜车惊喜超给力！',
      link: location.href,
      imgUrl: 'https://a-img.pangku.com/cs180824img.jpg'
    }
    console.log(shareData)
    if (isWeixin) {
      this.WeixinShare(shareData)
    } else {
      this.AlipayShare(shareData)
    }
  },
  methods: {
    WeixinShare(shareData) {
      wxApi.init(() => {
        wx.onMenuShareAppMessage(shareData) // 分享给朋友
        wx.onMenuShareTimeline(shareData) // 分享到朋友圈
        wx.onMenuShareQQ(shareData) // 分享到QQ
        wx.onMenuShareWeibo(shareData) // 分享到微博
      })
    },
    AlipayShare(shareData) {
      document.getElementsByTagName('head')[0].innerHTML += `<meta name="Alipay:title" content="${shareData.title}">
       <meta name="Alipay:desc" content="${shareData.desc}">
       <meta name="Alipay:link" content="${shareData.link}">
       <meta name="Alipay:imgUrl" content="${shareData.imgUrl}">`
    }
  }
}
</script>

<style lang="scss" scoped>
.share {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/cs180824/components/share.vue